<template>
  <div>
    <label class="flex items-start gap-2 text-sm text-foreground cursor-pointer">
      <input id="terms-accepted" v-model="accepted" type="checkbox" class="mt-0.5 shrink-0" />
      <i18n-t keypath="auth.termsLabel" tag="span" scope="global">
        <template #tos>
          <a
            :href="termsUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="underline font-medium text-primary hover:text-primary/80"
          >
            {{ $t('auth.termsOfService') }}
          </a>
        </template>
        <template #privacy>
          <a
            :href="privacyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="underline font-medium text-primary hover:text-primary/80"
          >
            {{ $t('auth.privacyPolicy') }}
          </a>
        </template>
      </i18n-t>
    </label>
    <p v-if="error" class="mt-1 text-sm text-destructive">{{ error }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const accepted = defineModel({ type: Boolean, required: true })

defineProps({
  error: { type: String, default: null },
})

const { locale } = useI18n()

const termsUrl = computed(() =>
  locale.value === 'en' ? '/en/terms-of-service' : '/termeni-si-conditii',
)
const privacyUrl = computed(() =>
  locale.value === 'en' ? '/en/privacy-policy' : '/politica-de-confidentialitate',
)
</script>
